module.exports = __webpack_public_path__ + "img/bell-hover.5ce38c83.svg";